











import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { defaultScales } from '@/utils/map'

@Component
export default class ScaleSelect extends Vue {
  @Prop({ default: 0 })
  readonly value: number

  scale = 0

  get defaultScales () {
    return defaultScales
  }

  get currentScaleText () {
    const currentScale = defaultScales.reduce((a: number, b: number) => Math.abs(b - this.scale) < Math.abs(a - this.scale) ? b : a)
    return this.formatScale(currentScale, currentScale !== this.scale)
  }

  formatScale (scale: number, near = false): string {
    let num = scale.toString().split('').reverse().join('')
    let result = ''
    const gapSize = 3

    while (num.length > 0) {
      result = `${result} ${num.substring(0, gapSize)}`
      num = num.substring(gapSize)
    }
    return `1 / ${near ? '~' : ''}${result.split('').reverse().join('')}`
  }

  setScale (scale: number) {
    this.scale = scale
    this.$emit('input', this.scale)
  }

  created () {
    if (this.value === 0 && defaultScales.length > 0) {
      this.setScale(defaultScales[0])
    }
  }

  @Watch('value', { immediate: true })
  onValueChanged (newVal: number) {
    this.scale = newVal
  }
}
